import React, { Component } from 'react';
import { ScrollView, View } from 'react-native';

import PropTypes from 'prop-types';

import { Icon, VFScreen, VFText } from '@vfgroup-oneplatform/foundation/Components';
import { withTheme, LightThemeColors } from '@vfgroup-oneplatform/foundation/Components/Themes';

import { PermissionsDescriptionSection, PermissionsItem } from '../../../CommonUI';
import { getThemeImages } from '../../../Themes';
import { ConfirmButton, SuccessModal } from '../../Components';

import styles from './ThirdPartyTracking.styles';

class ThirdPartyTracking extends Component {
  get images() {
    return getThemeImages(this.props.theme.name);
  }

  renderDescription = () => (
    <View style={styles.descriptionContainer}>
      <PermissionsDescriptionSection
        section={this.props.description}
        textColor={this.props.theme.colors.text.primaryGrey}
      />
    </View>
  );

  renderEssential = () => (
    <View style={[styles.cardView(this.props.theme), styles.essentialPadding]}>
      <View style={styles.essentialRow}>
        <Icon type="image" name={this.images.ic_indicators_admin} size={34} />

        <VFText
          style={styles.essentialTitle(this.props.theme)}
          i18nKey="third_party_tracking_essential"
        />

        <VFText
          style={styles.essentialState(this.props.theme)}
          i18nKey="third_party_tracking_essential_state"
        />
      </View>

      <VFText
        style={styles.essentialDescription(this.props.theme)}
        i18nKey="third_party_tracking_essential_description"
      />
    </View>
  );

  renderTrackers = () => {
    return this.props.trackers.map((tracker, i) => (
      <View key={i} style={styles.cardView(this.props.theme)}>
        {tracker.map((item, index) => (
          <PermissionsItem
            key={index}
            icon={item.icon}
            images={this.props.images}
            title={item.title}
            description={item.description}
            style={{ marginEnd: undefined }}
            titleStyle={{ color: this.props.theme.colors.text.primary }}
            descriptionStyle={styles.permissionItem(this.props.theme)}
            initialValue={item.initialValue}
            onAcceptanceChange={item.onAcceptanceChange}
          />
        ))}
      </View>
    ));
  };

  render() {
    return (
      <VFScreen
        title="third_party_tracking_title"
        showBack
        onBack={this.props.onBack}
        onClose={this.props.onClose}
        withHeaderSpace
      >
        <View style={styles.container}>
          <ScrollView contentContainerStyle={styles.scrollContainer}>
            {this.renderDescription()}
            {this.renderEssential()}
            {this.renderTrackers()}
          </ScrollView>

          <ConfirmButton
            isConfirmDisabled={this.props.isConfirmDisabled}
            onConfirm={this.props.onConfirmPress}
          />
        </View>

        <SuccessModal {...this.props.successModalProps} />
      </VFScreen>
    );
  }
}

ThirdPartyTracking.defaultProps = {
  theme: LightThemeColors,
};

ThirdPartyTracking.propTypes = {
  onBack: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  description: PropTypes.object,
  images: PropTypes.object.isRequired,
  trackers: PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.object)).isRequired,
  isConfirmDisabled: PropTypes.bool,
  onConfirmPress: PropTypes.func.isRequired,
  successModalProps: PropTypes.shape({
    isVisible: PropTypes.bool,
    onPrimaryPress: PropTypes.func,
    onSecondaryPress: PropTypes.func,
  }).isRequired,
  theme: PropTypes.object,
};

export default withTheme(ThirdPartyTracking);
